import { createContext } from 'react';

// Carries WorkflowBuilder's own `setNodes` (from useNodesState) down to NoteNode, so it can
// update its own text as the user types. A context is used (rather than putting a callback on
// node.data, which would need WorkflowBuilder to remap the whole `nodes` array through a
// useMemo before passing it to <ReactFlow>) because nodeTypes must stay a referentially-stable
// object defined outside the component — same reasoning as WorkflowEdgesContext for edges.
export const WorkflowNodesContext = createContext(null);
